/*
 * Copyright 2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

import React from "react";

//@todo spice it up with gopher graphic
export default () => {
    return (
        <div>
            <h3>Sorry, page not found!</h3>
        </div>
    );
}
